<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" parentStoreName="Coupons" :submit="submit"
    :status="status">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row justify="center">
        <v-col cols="6">
          <v-row>
            <v-col>
              <ValidationProvider ref="title" rules="required" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model="data.title" label="Título"></v-text-field>
              </ValidationProvider>
            </v-col>
            <!-- <v-col>
                <ValidationProvider
                  ref="code"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    :error-messages="errors"
                    v-model="data.code"
                    label="Código"
                  ></v-text-field>
                </ValidationProvider>
              </v-col> -->
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="type" rules="required" v-slot="{ errors }">
                <v-select :error-messages="errors" v-model="data.type" label="Tipo" :items="types">
                  <template slot="no-data">
                    <v-alert :value="true"> No hay datos a mostrar </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
            <v-col>
              <v-menu ref="menu_dead_line" v-model="menu_expire_date" :close-on-content-click="false"
                transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider ref="expire_date" rules="required" v-slot="{ errors }">
                    <v-text-field v-model="data.expire_date" label="Fecha de expiración" prepend-icon="fas fa-calendar"
                      readonly v-bind="attrs" v-on="on" :error-messages="errors"></v-text-field>
                  </ValidationProvider>
                </template>
                <v-date-picker v-model="expire_date" label="Project Duration" type="date" no-title scrollable
                  @change="menu_expire_date = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="discount_percentage" :rules="rules_discount_percentage" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model.number="data.discount_percentage" type="Number" min="1"
                  label="Porcentaje de descuento"></v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col>
              <ValidationProvider ref="fee_minutes" :rules="rules_fee_minutes" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model.number="data.fee_minutes" type="Number" min="1"
                  label="Minutos gratis"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <!-- <v-row>
              <v-col>
                <ValidationProvider ref="stock" rules="" v-slot="{ errors }">
                  <v-text-field
                    :error-messages="errors"
                    v-model.number="data.stock"
                    type="Number"
                    label="Stock"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row> -->
          <v-row>
            <v-col>
              <ValidationProvider ref="description" rules="required" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.description" label="Descripción"
                  rows="8"></v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select :error-messages="errors" v-model="selected_users" label="Usuarios" :items="usersCopy"
                item-value="id" :item-text="(row) => `${row.name || ''} ${row.last_name || ''}`" multiple search-input>
                <template #prepend-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-text-field v-model="searchUser" placeholder="Search" @input="searchUsers"></v-text-field>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider class="mt-2"></v-divider>

                  <v-list-item>
                    <v-list-item-action>
                      <v-checkbox v-model="selectAll" :indeterminate="selectAll === null" :input-value="false"
                        hide-details @click="clickSelectAll(selectAll)"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Seleccionar todos</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                </template>
                <template slot="no-data">
                  <v-alert :value="true"> No hay datos a mostrar </v-alert>
                </template>
              </v-select>
            </v-col>
            <v-col>
              <ModalAssignUser :users="selected_items" @selected_users="getDataUsers"></ModalAssignUser>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import ModalAssignUser from "@/components/modals/ModalAssignUser";
import CrudFormMixin from "@/mixins/crud_form";
import swal from "sweetalert";

extend("numberpositivo", {
  validate: (value) => {
    return value > 0;
  },
  message: "El campo debe ser mayor a 0.",
});

export default {
  mixins: [CrudFormMixin],
  components: {
    CrudForm,
    ValidationProvider,
    Upload,
    ValidationObserver,
    ModalAssignUser,
  },
  async created() {
    const self = this;

    await this.$store.dispatch("Users/getListAll", { show_all: 'enable', sorting_column: 'name', sorting_order: 'asc' })
    this.usersCopy = this.users;

    if (this.$route.params.id) {
      await self.$store
        .dispatch("Coupons/show", this.$route.params.id)
        .then((val) => {
          this.data.users = val.user_coupons.map(
            (user_coupon) => user_coupon.user_id
          );
        });
    }
  },
  data() {
    return {
      storeName: "Coupons",
      title: "Cupon",
      values: [],
      selected_users: [],
      data: {
        title: "",
        description: "",
        //code: "",
        discount_percentage: "",
        expire_date: "",
        type: "",
        fee_minutes: "",
        users: [],
        stock: 0,
        coupon_for_new_user: "",
      },
      types: ["discount", "free_minutes"],
      expire_date: "",
      menu_expire_date: false,
      selectAll: false,
      searchUser: '',
      usersCopy: [],
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Coupons.status,
      users: (state) => state.Users.list,
      selected_items(state) {
        const id_users = this.selected_users.map(String);
        return [...state.Users.list].filter((user) =>
          id_users.includes(user.id)
        );
      },
    }),
    rules_discount_percentage() {
      const rules = ["numberpositivo"];
      if (this.data.type == "discount") {
        rules.push("required");
      }
      return rules.join("|");
    },
    rules_fee_minutes() {
      const rules = ["numberpositivo"];
      if (this.data.type == "free_minutes") {
        rules.push("required");
      }
      return rules.join("|");
    },
  },
  watch: {
    expire_date(val) {
      this.expire_date = val;
      this.data.expire_date = this.formatDateForSave(val);
    },
    "selected_users"(newValue) {
      if (newValue.length === this.usersCopy.length) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },
  },
  methods: {
    clickSelectAll(value) {
      if (value) {
        this.selected_users = this.usersCopy.map(user => user.id);
      } else {
        this.selected_users = [];
      }
    },
    searchUsers() {
      if (!this.searchUser) {
        this.usersCopy = this.users;
      }
      this.usersCopy = this.users.filter(user => {
        let full_name = `${user.name || ''} ${user.last_name || ''}`;
        return full_name.toLowerCase().indexOf(this.searchUser.toLowerCase()) > -1
      })
    },
    getDataUsers(val) {
      this.data.users = val;
    },
    buildRootUrl() {
      return `/admin/coupons`;
    },
    async submit() {

      const self = this;
      let valid = await self.$refs.validator.validate();
      if (valid) {
        /* let saveUrl = this.$route.params.id
          ? `${this.storeName}/update`
          : `${this.storeName}/create`; */
        self.$store
          .dispatch("Coupons/create_bulk", self.data)
          .then(function () {
            swal("creacion de cupon exitosa", "exitosamente!!", "success", {
              timer: 3000,
            });
            self.$router.push(self.buildRootUrl());
          })
          .catch(function (response) {
            if (response && response.message && response.message.patent) {
              eval(
                "self.$refs." +
                "patent" +
                ".setErrors(response.message.patent[0]);"
              );
            }

            for (const i in response.errors) {
              try {
                eval("self.$refs." + i + ".setErrors(response.errors[i]);");
              } catch (error) {
                //
              }
            }
          });
      }
    },
  },
};
</script>
